export const toneOfVoice = [
  "Friendly",
  "Professional",
  "Witty",
  "Sarcastic",
  "Formal",
  "Casual",
  "Empathetic",
  "Authoritative",
];

export const writingStyle = [
  "Conversational",
  "Descriptive",
  "Persuasive",
  "Narrative",
  "Expository",
  "Analytical",
  "Poetic",
  "Technical",
];

export const targetAudience = [
  "General public",
  "Children",
  "Teenagers",
  "Young adults",
  "Professionals",
  "Academics",
  "Business owners",
  "Specific hobbyists",
];

export const purposeIntent = [
  "Inform",
  "Entertain",
  "Persuade",
  "Educate",
  "Inspire",
  "Warn",
  "Sell",
  "Reflect",
];

export const pointOfView = [
  "First person",
  "Second person",
  "Third person",
  "Omniscient",
  "Limited",
];
